import React from 'react'
import { formatDisplayShorthand } from '../../../../../../utils/formatDisplay'

export const ValueCell = ({ value, row }: any) => {
    if (row.original.name === "veSHELL") {
        return <span>--</span>;
    }

    return <span>${formatDisplayShorthand(value)}</span>;
};